// import {
//   User2Icon,
//   X,
//   Mail,
//   Phone,
//   Globe,
//   UserCheck,
//   ArrowUpRight,
//   Building2,
//   Image,
//   KeyRound,
// } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import React, { useState, useEffect } from "react";
// import {
//   UpdatePartnerPNT,
//   UpdatePartnerENT,
//   updatePartnerData,
// } from "../../services/partner/partner";
// import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";

// function EditPage({ data, onClose, activeTab }) {
//   // console.log("activeTab", activeTab);
//   const [form, setForm] = useState({
//     partner_id: "",
//     email_address: "",
//     mobile_number: "",
//     company_domain: "",
//     partner_domain: "",
//     referred_by: "",
//     company_name: "",
//     brand_name: "",
//     support_mail_id: "",
//     whatsapp_number: "",
//     calling_number: "",
//     mobile_number_original: "",
//     email_id_original: "",
//     logo: "",
//   });

//   const [logoError, setLogoError] = useState("");

//   useEffect(() => {
//     if (data) {
//       setForm({
//         partner_id: data.partner_id || "",
//         email_address: data.email_address || "",
//         mobile_number: data.mobile_number || "",
//         company_domain: data.company_domain || "",
//         partner_domain: data.partner_domain || "",
//         referred_by: data.referred_by || "",
//         company_name: data.company_name || "",
//         brand_name: data.brand_name || "",
//         support_mail_id: data.support_mail_id || "",
//         whatsapp_number: data.whatsapp_number || "",
//         calling_number: data.calling_number || "",
//         mobile_number_original: data.mobile_number_original || "",
//         email_id_original: data.email_id_original || "",
//         logo: "",
//       });
//     }
//   }, [data]);

//   const buildPayload = () => {
//     const formData = new FormData();

//     if (activeTab === "PNT") {
//       formData.append("email", form.email_address);
//       formData.append("mobile", form.mobile_number);
//       formData.append("partner_domain", form.company_domain);
//       //   formData.append("referred_by", form.referred_by);
//       formData.append("partner_id", form.partner_id);
//     }

//     if (activeTab === "ENT") {
//       formData.append("mobile", form.mobile_number_original);
//       formData.append("email", form.email_id_original);
//       formData.append("company_name", form.company_name);
//       formData.append("brand_name", form.brand_name);
//       formData.append("support_mail_id", form.support_mail_id);
//       formData.append("whatsapp_number", form.whatsapp_number);
//       formData.append("calling_number", form.calling_number);
//       formData.append("partner_domain", form.partner_domain);
//       //   formData.append("referred_by", form.referred_by);
//       formData.append("partner_id", form.partner_id);

//       if (form.logo) {
//         formData.append("logo", form.logo);
//       }
//     }

//     return formData;
//   };

// const handleChange = (e) => {
//   const { name, files, value } = e.target;

//   if (files?.length) {
//     const file = files[0];

//     if (file.size > 2 * 1024 * 1024) {
//       return setLogoError("Upload file less than 2 MB");
//     }

//     const allowedTypes = ["image/jpeg", "image/png"];

//     if (!allowedTypes.includes(file.type)) {
//       return setLogoError("File type should be PNG, JPG or JPEG");
//     }

//     setLogoError("");

//     setForm((prev) => ({
//       ...prev,
//       [name]: file,
//     }));

//     return;
//   }

//   if (["mobile_number", "whatsapp_number", "calling_number"].includes(name)) {
//     if (!/^\d*$/.test(value)) return;
//     if (value.length > 10) return;
//   }

//   setForm((prev) => ({
//     ...prev,
//     [name]: value,
//   }));
// };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const payload = buildPayload();

     

//       const res = await updatePartnerData(payload, form.partner_id);

//       // console.log("Update response:", res);

//       if (res?.data?.status === 200 ||
//         res?.status === true ||  res?.data?.status === true ||
//         res?.status?.code === 200 ||
//         res?.status === 200
//       ) {
//         showSuccessToast(res?.message || res?.data?.message || res?.data?.data?.message  || "Partner updated successfully");
//         onClose();
//       } else {
//         console.error("Update failed:", res);
//         showErrorToast(res?.message || res?.data?.message || res?.data?.data?.message)
//       }
//     } catch (err) {
//       console.error("Submit error:", err);
//     }
//   };

//   if (!data) return null;

//   return (
//     <AnimatePresence>
//       <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
//         <motion.div
//           initial={{ opacity: 0 }}
//           animate={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           onClick={onClose}
//           className="absolute inset-0 bg-slate-400/20 backdrop-blur-sm"
//         />

//         <motion.div
//           initial={{ scale: 0.95, opacity: 0 }}
//           animate={{ scale: 1, opacity: 1 }}
//           exit={{ scale: 0.95, opacity: 0 }}
//           className="relative w-full max-w-3xl bg-white border border-slate-200 rounded-[2rem] shadow-xl overflow-hidden"
//         >
//           <div className="h-32 bg-gradient-to-br from-cyan-50 to-blue-100 border-b" />

//           <button
//             onClick={onClose}
//             className="absolute top-6 right-6 p-2 bg-white rounded-full"
//           >
//             <X size={18} />
//           </button>

//           <div className="px-8 pb-10 -mt-16">
//             <div className="flex items-end gap-6 mb-10">
//               <div className="w-28 h-28 rounded-3xl bg-gradient-to-r from-cyan-600 to-blue-800 flex items-center justify-center">
//                 <User2Icon className="text-white w-10 h-10" />
//               </div>

//               <div>
//                 <h2 className="text-xl font-bold">Edit Partner</h2>
//                 <p className="text-blue-600">{form.partner_id}</p>
//               </div>
//             </div>

//             <form className="grid grid-cols-2 gap-5" onSubmit={handleSubmit}>
//               {activeTab === "ENT" && (
//                 <>
//                   <InputField
//                     icon={<Phone />}
//                     label="Mobile Number"
//                     name="mobile_number_original"
//                     value={form.mobile_number_original}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Mail />}
//                     label="Email Address"
//                     name="email_id_original"
//                     value={form.email_id_original}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Building2 />}
//                     label="Company Name"
//                     name="company_name"
//                     value={form.company_name}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Building2 />}
//                     label="Brand Name"
//                     name="brand_name"
//                     value={form.brand_name}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Mail />}
//                     label="Support Email"
//                     name="support_mail_id"
//                     value={form.support_mail_id}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Phone />}
//                     label="WhatsApp Number"
//                     name="whatsapp_number"
//                     value={form.whatsapp_number}
//                     onChange={handleChange}
//                   />

//                   <InputField
//                     icon={<Phone />}
//                     label="Calling Number"
//                     name="calling_number"
//                     value={form.calling_number}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<KeyRound />}
//                     label="Google Captach Key"
//                     name="google_captcha_key"
//                     value={form.company_domain}
//                     onChange={handleChange}
//                   />

//                   <InputField
//                     icon={<Globe />}
//                     label="Partner Register Domain"
//                     name="partner_domain"
//                     value={form.partner_domain}
//                     onChange={handleChange}
//                   />
//                   {/* <InputField
//                     icon={<UserCheck />}
//                     label="Referred By"
//                     name="referred_by"
//                     value={form.referred_by}
//                     onChange={handleChange}
//                   /> */}

//                   <InputField
//                     icon={<Image />}
//                     logoError={logoError}
//                     type={"file"}
//                     label="Logo URL"
//                     logo={form.logo}
//                     name="logo"
//                     onChange={handleChange}
//                   />

//                   <div className="col-span-2 flex justify-end gap-3 mt-4">
//                     <button
//                       type="button"
//                       onClick={onClose}
//                       className="bg-gray-400 text-white px-4 py-2 rounded"
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       type="submit"
//                       className="bg-gradient-to-r from-cyan-600 to-blue-800 text-white px-5 py-2 rounded flex items-center gap-2"
//                     >
//                       <ArrowUpRight size={16} />
//                       Update
//                     </button>
//                   </div>
//                 </>
//               )}

//               {activeTab === "PNT" && (
//                 <>
//                   <InputField
//                     icon={<Phone />}
//                     label="Mobile Number"
//                     name="mobile_number"
//                     value={form.mobile_number}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Mail />}
//                     label="Email Address"
//                     name="email_address"
//                     value={form.email_address}
//                     onChange={handleChange}
//                   />
//                   <InputField
//                     icon={<Globe />}
//                     label="Company Domain"
//                     name="company_domain"
//                     value={form.company_domain}
//                     onChange={handleChange}
//                   />
//                   {/* <InputField
//                     icon={<UserCheck />}
//                     label="Referred By"
//                     name="referred_by"
//                     value={form.referred_by}
//                     onChange={handleChange}
//                   /> */}

//                   <div className="col-span-2 flex justify-end gap-3 mt-4">
//                     <button
//                       type="button"
//                       onClick={onClose}
//                       className="bg-gray-400 text-white px-4 py-2 rounded"
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       type="submit"
//                       className="bg-gradient-to-r from-cyan-600 to-blue-800 text-white px-5 py-2 rounded flex items-center gap-2"
//                     >
//                       <ArrowUpRight size={16} />
//                       Update
//                     </button>
//                   </div>
//                 </>
//               )}
//             </form>
//           </div>
//         </motion.div>
//       </div>
//     </AnimatePresence>
//   );
// }

// function InputField({ icon, label, name, value, onChange, type, logoError, logo }) {
//   return (
//     <div>
//       <div className="flex items-center justify-between">
//         <label className="text-xs text-gray-400 mb-1 block">{label}</label>
//         {type === "file" && (
//           <p className="text-xs text-gray-400">Max-2MB (Png, jpg, jpeg)</p>
//         )}
//       </div>
//       <div className="flex  items-center gap-2 border rounded px-3 py-2 bg-gray-50">
//         {React.cloneElement(icon, { size: 16 })}
//         <input
//           type={type || "text"}
//           name={name}
//           value={value || undefined}
//           onChange={onChange}
//           className="bg-transparent outline-none w-full"
//         />
//       </div>
//       {type === "file" && (
//         <p
//           className={`text-xs mt-2  ${logoError ? "text-red-700 animate-pulse" : "text-gray-400"}`}
//         >
//           {logoError
//             ? logoError : logo ? logo.name
//             : "Don't add logo if you want to keep existing one"}
//         </p>
//       )}
//     </div>
//   );
// }

// export default EditPage;


import {
  User2Icon,
  X,
  Mail,
  Phone,
  Globe,
  UserCheck,
  ArrowUpRight,
  Building2,
  Image,
  KeyRound,
  CreditCard,
  Hash,
  QrCode,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import React, { useState, useEffect } from "react";
import {
  UpdatePartnerPNT,
  UpdatePartnerENT,
  updatePartnerData,
} from "../../services/partner/partner";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";

function EditPage({ data, onClose, activeTab }) {
  const [form, setForm] = useState({
    partner_id: "",
    email_address: "",
    mobile_number: "",
    company_domain: "",
    partner_domain: "",
    referred_by: "",
    company_name: "",
    brand_name: "",
    support_mail_id: "",
    whatsapp_number: "",
    calling_number: "",
    mobile_number_original: "",
    email_id_original: "",
    logo: "",
    account_no: "",
    ifsc_code: "",
    upi_id: "",
    qr: "",
  });

  const [logoError, setLogoError] = useState("");
  const [qrError, setQrError] = useState("");

  useEffect(() => {
    if (data) {
      setForm({
        partner_id: data.partner_id || "",
        email_address: data.email_address || "",
        mobile_number: data.mobile_number || "",
        company_domain: data.company_domain || "",
        partner_domain: data.partner_domain || "",
        referred_by: data.referred_by || "",
        company_name: data.company_name || "",
        brand_name: data.brand_name || "",
        support_mail_id: data.support_mail_id || "",
        whatsapp_number: data.whatsapp_number || "",
        calling_number: data.calling_number || "",
        mobile_number_original: data.mobile_number_original || "",
        email_id_original: data.email_id_original || "",
        logo: "",
        account_no: data.payment_details?.account_no || "",
        ifsc_code: data.payment_details?.ifsc_code || "",
        upi_id: data.payment_details?.upi_id || "",
        qr: "",
      });
    }
  }, [data]);

  const buildPayload = () => {
    const formData = new FormData();

    if (activeTab === "PNT") {
      formData.append("email", form.email_address);
      formData.append("mobile", form.mobile_number);
      formData.append("partner_domain", form.company_domain);
      // formData.append("referred_by", form.referred_by);
      formData.append("partner_id", form.partner_id);
    }

    if (activeTab === "ENT") {
      formData.append("mobile", form.mobile_number_original);
      formData.append("email", form.email_id_original);
      formData.append("company_name", form.company_name);
      formData.append("brand_name", form.brand_name);
      formData.append("support_mail_id", form.support_mail_id);
      formData.append("whatsapp_number", form.whatsapp_number);
      formData.append("calling_number", form.calling_number);
      formData.append("partner_domain", form.partner_domain);
      // formData.append("referred_by", form.referred_by);
      formData.append("partner_id", form.partner_id);
      formData.append("account_no", form.account_no);
      formData.append("ifsc_code", form.ifsc_code);
      formData.append("upi_id", form.upi_id);

      if (form.logo) {
        formData.append("logo", form.logo);
      }

      if (form.qr) {
        formData.append("qr", form.qr);
      }
    }

    return formData;
  };

  const handleChange = (e) => {
    const { name, files, value } = e.target;

    if (files?.length) {
      const file = files[0];

      if (file.size > 2 * 1024 * 1024) {
        if (name === "logo") return setLogoError("Upload file less than 2 MB");
        if (name === "qr") return setQrError("Upload file less than 2 MB");
        return;
      }

      const allowedTypes = ["image/jpeg", "image/png"];

      if (!allowedTypes.includes(file.type)) {
        if (name === "logo") return setLogoError("File type should be PNG, JPG or JPEG");
        if (name === "qr") return setQrError("File type should be PNG, JPG or JPEG");
        return;
      }

      if (name === "logo") setLogoError("");
      if (name === "qr") setQrError("");

      setForm((prev) => ({
        ...prev,
        [name]: file,
      }));

      return;
    }

    if (["mobile_number", "whatsapp_number", "calling_number"].includes(name)) {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = buildPayload();
      const res = await updatePartnerData(payload, form.partner_id);

      if (
        res?.data?.status === 200 ||
        res?.status === true ||
        res?.data?.status === true ||
        res?.status?.code === 200 ||
        res?.status === 200
      ) {
        showSuccessToast(
          res?.message || res?.data?.message || res?.data?.data?.message || "Partner updated successfully"
        );
        onClose();
      } else {
        console.error("Update failed:", res);
        showErrorToast(res?.message || res?.data?.message || res?.data?.data?.message);
      }
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  if (!data) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="absolute inset-0 bg-slate-400/20 backdrop-blur-sm"
        />

        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          className="relative w-full max-w-5xl bg-white border border-slate-200 rounded-[2rem] shadow-xl overflow-hidden"
        >
          <div className="h-32 bg-gradient-to-br from-cyan-50 to-blue-100 border-b" />

          <button onClick={onClose} className="absolute top-6 right-6 p-2 bg-white rounded-full">
            <X size={18} />
          </button>

          <div className="px-8 pb-10 -mt-16">
            <div className="flex items-end gap-6 mb-10">
              <div className="w-28 h-28 rounded-3xl bg-gradient-to-r from-cyan-600 to-blue-800 flex items-center justify-center">
                <User2Icon className="text-white w-10 h-10" />
              </div>

              <div>
                <h2 className="text-xl font-bold">Edit Partner</h2>
                <p className="text-blue-600">{form.partner_id}</p>
              </div>
            </div>

            <form className="grid grid-cols-3 gap-5" onSubmit={handleSubmit}>
              {activeTab === "ENT" && (
                <>
                  <InputField
                    icon={<Phone />}
                    label="Mobile Number"
                    name="mobile_number_original"
                    value={form.mobile_number_original}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Mail />}
                    label="Email Address"
                    name="email_id_original"
                    value={form.email_id_original}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Building2 />}
                    label="Company Name"
                    name="company_name"
                    value={form.company_name}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Building2 />}
                    label="Brand Name"
                    name="brand_name"
                    value={form.brand_name}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Mail />}
                    label="Support Email"
                    name="support_mail_id"
                    value={form.support_mail_id}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Phone />}
                    label="WhatsApp Number"
                    name="whatsapp_number"
                    value={form.whatsapp_number}
                    onChange={handleChange}
                  />

                  <InputField
                    icon={<Phone />}
                    label="Calling Number"
                    name="calling_number"
                    value={form.calling_number}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<KeyRound />}
                    label="Google Captcha Key"
                    name="google_captcha_key"
                    value={form.company_domain}
                    onChange={handleChange}
                  />

                  <InputField
                    icon={<Globe />}
                    label="Partner Register Domain"
                    name="partner_domain"
                    value={form.partner_domain}
                    onChange={handleChange}
                  />

                  {/* New Fields */}
                  <InputField
                    icon={<CreditCard />}
                    label="Account Number"
                    name="account_no"
                    value={form.account_no}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Hash />}
                    label="IFSC Code"
                    name="ifsc_code"
                    value={form.ifsc_code}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<QrCode />}
                    label="UPI ID"
                    name="upi_id"
                    value={form.upi_id}
                    onChange={handleChange}
                  />

                  <InputField
                    icon={<Image />}
                    fileError={logoError}
                    type="file"
                    label="Logo URL"
                    fileObj={form.logo}
                    fileTypeLabel="logo"
                    name="logo"
                    onChange={handleChange}
                  />

                  <InputField
                    icon={<Image />}
                    fileError={qrError}
                    type="file"
                    label="QR Code"
                    fileObj={form.qr}
                    fileTypeLabel="QR code"
                    name="qr"
                    onChange={handleChange}
                  />

                  <div className="col-span-2 flex justify-end gap-3 mt-4">
                    <button type="button" onClick={onClose} className="bg-gray-400 text-white px-4 py-2 rounded">
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="bg-gradient-to-r from-cyan-600 to-blue-800 text-white px-5 py-2 rounded flex items-center gap-2"
                    >
                      <ArrowUpRight size={16} />
                      Update
                    </button>
                  </div>
                </>
              )}

              {activeTab === "PNT" && (
                <>
                  <InputField
                    icon={<Phone />}
                    label="Mobile Number"
                    name="mobile_number"
                    value={form.mobile_number}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Mail />}
                    label="Email Address"
                    name="email_address"
                    value={form.email_address}
                    onChange={handleChange}
                  />
                  <InputField
                    icon={<Globe />}
                    label="Company Domain"
                    name="company_domain"
                    value={form.company_domain}
                    onChange={handleChange}
                  />

                  <div className="col-span-2 flex justify-end gap-3 mt-4">
                    <button type="button" onClick={onClose} className="bg-gray-400 text-white px-4 py-2 rounded">
                      Cancel
                    </button>

                    <button
                      type="submit"
                      className="bg-gradient-to-r from-cyan-600 to-blue-800 text-white px-5 py-2 rounded flex items-center gap-2"
                    >
                      <ArrowUpRight size={16} />
                      Update
                    </button>
                  </div>
                </>
              )}
            </form>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}

function InputField({ icon, label, name, value, onChange, type, fileError, fileObj, fileTypeLabel }) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <label className="text-xs text-gray-400 mb-1 block">{label}</label>
        {type === "file" && <p className="text-xs text-gray-400">Max-2MB (Png, jpg, jpeg)</p>}
      </div>
      <div className="flex items-center gap-2 border rounded px-3 py-2 bg-gray-50">
        {React.cloneElement(icon, { size: 16 })}
        <input
          type={type || "text"}
          name={name}
          value={type === "file" ? undefined : value || ""}
          onChange={onChange}
          className="bg-transparent outline-none w-full"
        />
      </div>
      {type === "file" && (
        <p className={`text-xs mt-2 ${fileError ? "text-red-700 animate-pulse" : "text-gray-400"}`}>
          {fileError
            ? fileError
            : fileObj
            ? fileObj.name
            : `Don't add ${fileTypeLabel} if you want to keep existing one`}
        </p>
      )}
    </div>
  );
}

export default EditPage;